import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private titleService = inject(Title);
  private userService = inject(UserService);


  public setTitle(title: string, schoolId?: string) {
    const isAidQuiz = schoolId === 'aidquiz' || this.userService.isAidQuiz;
    const fullTitle = title + ' | ' + (isAidQuiz ? 'Financial Aid Quiz' : 'Net Price Calculator');
    this.titleService.setTitle(fullTitle);
  }
}
